module.exports = __webpack_public_path__ + "img/ic_stripe.4d28ba0d.svg";